import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

const API_PATH = API_URL + "employeedeficit";

// Get employee deficits with optional filtering
const getEmployeeDeficits = (
  startShiftId?: number,
  endShiftId?: number,
  isDeducted?: boolean
) => {
  let params = {};
  
  if (startShiftId && endShiftId) {
    params = { ...params, startshift: startShiftId, endshift: endShiftId };
  }
  
  if (isDeducted !== undefined) {
    params = { ...params, isdeducted: isDeducted };
  }
  
  return axios.get(`${API_PATH}/employeedeficits`, {
    headers: authHeader(),
    params
  });
};

// Save or update employee deficits
const saveEmployeeDeficits = (deficits: any[]) => {
  return axios.post(`${API_PATH}/employeedeficits`, deficits, {
    headers: authHeader()
  });
};

// Update isDeducted status for employee deficits
const updateIsDeducted = (deficits: any[]) => {
  return axios.post(`${API_PATH}/isdeducted`, deficits, {
    headers: authHeader()
  });
};

const employeeDeficitService = {
  getEmployeeDeficits,
  saveEmployeeDeficits,
  updateIsDeducted
};

export default employeeDeficitService; 